import React from "react";
import { useSelector } from "react-redux";
import Popup from "../../../../shared/components/ui/popup/Popup";
import MessagesWidget from "../messagesWidget/MessagesWidget";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import classes from "./MessagesPopup.module.css";

const MessagesPopup = ({ onClose }) => {

    const { texts } = useSelector(state => state.translate);

    return (
        <Popup close={onClose} title={texts.messagesBoard} icon={iconsList.messages} dropClass={classes.MessagesPopup}>
            <MessagesWidget />
        </Popup>
    );
};

export default MessagesPopup;
